export const FEAT_ORIGINAL_EQUIPMENT_MANUFACTURER =
  'ORIGINAL_EQUIPMENT_MANUFACTURER'
